<template>
  <div class="address-management">
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="收货人姓名">
          <el-input v-model="searchForm.receiverName" placeholder="请输入收货人姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-input v-model="searchForm.phone" placeholder="请输入用户手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
          <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div slot="header" class="clearfix">
        <el-button type="primary" @click="handleAdd" icon="el-icon-plus">新增地址</el-button>
      </div>

      <el-table :data="tableData" border stripe v-loading="tableLoading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="receiverName" label="收货人姓名" width="100"></el-table-column>
        <el-table-column prop="phone" label="收货人电话" width="120">
          <template slot-scope="scope">
            {{ scope.row.phone || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="detailAddress" label="所在地区" min-width="200">
          <template slot-scope="scope">
            {{ formatRegion(scope.row) }}{{ scope.row.detailAddress }}
          </template>
        </el-table-column>
        <el-table-column prop="isDefault" label="默认" width="60">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isDefault === 1" type="warning" size="small">默认</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '正常' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleSetDefault(scope.row)" v-if="scope.row.isDefault !== 1">设为默认</el-button>
            <el-button type="text" size="small" @click="handleStatus(scope.row)">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, prev, pager, next"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="收货人姓名" prop="receiverName">
          <el-input v-model="form.receiverName" placeholder="请输入收货人姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="省/直辖市" prop="province">
          <el-input v-model="form.province" placeholder="如：上海市、广东省"></el-input>
        </el-form-item>
        <el-form-item label="市（直辖市可留空）" prop="city">
          <el-input v-model="form.city" placeholder="直辖市留空，如：深圳市"></el-input>
        </el-form-item>
        <el-form-item label="区/县" prop="district">
          <el-input v-model="form.district" placeholder="如：浦东区、南山区"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailAddress">
          <el-input v-model="form.detailAddress" type="textarea" :rows="2" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="设为默认">
          <el-switch v-model="form.isDefault" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情对话框 -->
    <el-dialog title="地址详情" :visible.sync="viewDialogVisible" width="600px">
      <el-descriptions :column="2" border v-if="viewData">
        <el-descriptions-item label="ID">{{ viewData.id }}</el-descriptions-item>
        <el-descriptions-item label="收货人姓名">{{ viewData.receiverName }}</el-descriptions-item>
        <el-descriptions-item label="收货人电话">{{ viewData.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="所在地区" :span="2">{{ formatRegion(viewData) }}{{ viewData.detailAddress }}</el-descriptions-item>
        <el-descriptions-item label="是否默认">
          <el-tag v-if="viewData.isDefault === 1" type="warning" size="small">默认</el-tag>
          <span v-else>否</span>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="viewData.status === 1 ? 'success' : 'danger'" size="small">
            {{ viewData.status === 1 ? '正常' : '禁用' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDate(viewData.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatDate(viewData.updateTime) }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { getAddressList, getAddress, updateAddressStatus, deleteAddress, h5AddAddress, h5UpdateAddress, h5SetDefaultAddress } from '@/api'

export default {
  name: 'AddressManagement',
  data() {
    return {
      searchForm: {
        receiverName: '',
        phone: '',
        status: null
      },
      tableData: [],
      tableLoading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      form: {
        id: null,
        receiverName: '',
        phone: '',
        province: '',
        city: '',
        district: '',
        detailAddress: '',
        isDefault: 0
      },
      rules: {
        receiverName: [
          { required: true, message: '请输入收货人姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '请填写省/直辖市', trigger: 'blur' }
        ],
        district: [
          { required: true, message: '请填写区/县', trigger: 'blur' }
        ],
        detailAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]
      },
      viewDialogVisible: false,
      viewData: null
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.tableLoading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        const res = await getAddressList(params)
        this.tableData = res.data.list || []
        this.pagination.total = res.data.total || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.tableLoading = false
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = {
        receiverName: '',
        phone: '',
        status: null
      }
      this.handleSearch()
    },
    handlePageChange(val) {
      this.pagination.pageNum = val
      this.loadData()
    },
    handleAdd() {
      this.dialogTitle = '新增地址'
      this.form = {
        id: null,
        receiverName: '',
        phone: '',
        province: '',
        city: '',
        district: '',
        detailAddress: '',
        isDefault: 0
      }
      this.dialogVisible = true
    },
    async handleEdit(row) {
      try {
        const res = await getAddress(row.id)
        this.form = {
          id: res.data.id,
          receiverName: res.data.receiverName,
          phone: res.data.phone,
          province: res.data.province,
          city: res.data.city,
          district: res.data.district || '',
          detailAddress: res.data.detailAddress,
          isDefault: res.data.isDefault || 0
        }
        this.dialogTitle = '编辑地址'
        this.dialogVisible = true
      } catch (e) {
        console.error(e)
      }
    },
    handleDialogClose() {
      this.$refs.form.resetFields()
    },
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.normalizeRegionForSubmit()
          this.submitLoading = true
          try {
            if (this.form.id) {
              // 编辑
              await h5UpdateAddress(this.form.id, {
                receiverName: this.form.receiverName,
                phone: this.form.phone,
                province: this.form.province,
                city: this.form.city,
                district: this.form.district,
                detailAddress: this.form.detailAddress,
                isDefault: this.form.isDefault
              })
              this.$message.success('更新成功')
            } else {
              // 新增
              await h5AddAddress({
                receiverName: this.form.receiverName,
                phone: this.form.phone,
                province: this.form.province,
                city: this.form.city,
                district: this.form.district,
                detailAddress: this.form.detailAddress,
                isDefault: this.form.isDefault
              })
              this.$message.success('添加成功')
            }
            this.dialogVisible = false
            this.loadData()
          } catch (e) {
            console.error(e)
          } finally {
            this.submitLoading = false
          }
        }
      })
    },
    async handleSetDefault(row) {
      try {
        await h5SetDefaultAddress(row.id)
        this.$message.success('设置默认成功')
        this.loadData()
      } catch (e) {
        console.error(e)
      }
    },
    async handleStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1
      const text = newStatus === 1 ? '启用' : '禁用'
      try {
        await this.$confirm(`确定要${text}该地址吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await updateAddressStatus(row.id, newStatus)
        this.$message.success(`${text}成功`)
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
        }
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该地址吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteAddress(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
        }
      }
    },
    async handleView(row) {
      try {
        const res = await getAddress(row.id)
        this.viewData = res.data
        this.viewDialogVisible = true
      } catch (e) {
        console.error(e)
      }
    },
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleString()
    },
    // 直辖市：北京/上海/天津/重庆，展示时省+区，不重复市
    formatRegion(row) {
      if (!row) return ''
      const p = row.province || ''
      const c = row.city || ''
      const d = row.district || ''
      const directMunicipalities = ['北京市', '上海市', '天津市', '重庆市']
      if (directMunicipalities.includes(p) && p === c) {
        return p + d
      }
      return p + c + d
    },
    // 提交前：直辖市若市为空则用省填充
    normalizeRegionForSubmit() {
      const directMunicipalities = ['北京市', '上海市', '天津市', '重庆市']
      if (directMunicipalities.includes(this.form.province) && !this.form.city) {
        this.form.city = this.form.province
      }
    }
  }
}
</script>

<style scoped lang="scss">
.address-management {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: 500px;
}
</style>
